export const configurableColumns = [
    { id: "siteName", name: "Site Name" },
    { id: "siteTypeFromImagery", name: "Site Type (from imagery)" },
    { id: "subpartWSegment", name: "Subject to" },
    { id: "operatorUniqueIds", name: "Operator IDs" },
    { id: "location", name: "Location" },
    { id: "emissionStats", name: "Has Emissions" },
    { id: "hasExternalProvider", name: "Onsite Sensors" },
    { id: "dateOfInstallation", name: "Installation Date" },
];
